import BasePage from "@Scripts/Pages/BasePage";
import FormHelper from "@Scripts/Common/FormHelper";

export default class CheckoutProfileEditPage extends BasePage {
    public static async init() {
        await super.init();

        var $form = $("#FormProfileEdit");

        (<any>$form).ajaxForm({
            iframe: false,
            beforeSubmit: function (formData, jqForm, options) {
                FormHelper.resetValidation($form);
                FormHelper.disableControls($form);
            },
            success: function (data) {
                FormHelper.resetValidation($form);

                window.location = (<any>window).App.routes.Checkout_Summary;
            },
            error: function (xhr, textStatus, errorThrown) {
                FormHelper.enableControls($form);
                FormHelper.setValidation($form, [{ Name: "Server", Errors: errorThrown }]);
            }
        });

        setProfileTaxType();
        setShippingData();
        setTermsData();

        $("#ProfileTaxType", $form).on("change", function () { setProfileTaxType(); });
        $("input[name=ShippingMode]", $form).on("change", function () { setShippingData(); });

        function setProfileTaxType() {
            if ($("#ProfileTaxType", $form).val() === "Persona giuridica") {
                $(".ivacode-box", $form).show();
            } else {
                $(".ivacode-box", $form).hide();
                $("[name='IVACode']").val("");
                $("[name='Company']").val("");
                $("[name='SDICode']").val("");
                $("[name='CertifiedEmail']").val("");
            }
        }

        function setShippingData() {
            if ($("input[name=ShippingMode]:checked", $form).val() === "ShippingAddress") {
                $(".shippingdata-box", $form).show();
                $(".storepickup-box", $form).hide();
            } else {
                $(".shippingdata-box", $form).hide();
                $(".storepickup-box", $form).hide();
            }
        }

        function setTermsData() {
            if ($("#IsCheckoutValidated", $form).val() === "False") {
                $(".terms-box", $form).show();
            } else {
                $(".terms-box", $form).hide();
            }
        }
    }
}